<!-- 菜单管理 -->
<template>
  <div class="menu-body">
    <!-- 菜单头部 -->
    <div class="menu-head">
      <div class="menu-head-button" @click="slideShow1()">
        <i class="menu-head-icon"></i>
      </div>
      <div class="menu-head-title">
        <!-- <span class="icon icon-logo"></span> -->
        <span>社会实践数据中心</span>
      </div>
      <div class="loginUser">
        <div class="user-info">
          <!-- <span class="user-info-picture"></span> -->
          <i class="el-icon-edit" style="line-height:26px;color:#2178ec;"></i>
          <span class="user-info-setPassword" @click="modPassword()">修改密码</span>
          <span class="user-info-setPassword-riLine"></span>
          <span class="user-info-name">{{ userInfo.username }}</span>
          <span class="user-info-leftarrow el-icon-switch-button" @click="logout()"></span>
        </div>
      </div>
    </div>
    <!-- 侧边拉伸主菜单 -->
    <div class="menu-slide">
      <transition name="fade">
        <div class="menu-slide-shade" v-if="slideShow" @click="slideShow = false"></div>
      </transition>
      <div class="menu-slide-wrapper" :class="{'is-visible':slideShow}">
        <el-menu
          default-active="0"
          class="menu-vertical"
          text-color="#666666"
          active-text-color="#000000"
          @open="handleOpen"
          @close="handleClose"
          @select="handleSelect"
        >
          <template v-for="(item,index) of menuTree">
            <template v-if="item.menuId == 9">
              <template v-if="userInfo.authStatus == 1">
                <el-menu-item :index="String(item.menuId)" :key="index" @click="toTwoMenu(item)">
                  <i :class="item.icon"></i>
                  <span slot="title">{{ item.name }}</span>
                </el-menu-item>
              </template>
            </template>
            <template v-else>
              <el-menu-item :index="String(item.menuId)" :key="index" @click="toTwoMenu(item)">
                <i :class="item.icon"></i>
                <span slot="title">{{ item.name }}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </div>
    </div>
    <!-- 内容展示部分 -->
    <div class="main-body">
      <!-- 侧边模块菜单 -->
      <div class="second-menu" v-if="thisPath != '/survey/detail'" :class="{'is-active-second':modelslideShow}">
        <div style="height: 100%;overflow-y: auto;">
          <el-menu
            :default-active="thisPath"
            :router="true"
            :default-openeds="openeds"
            class="menu-vertical"
            text-color="#666666"
            active-text-color="#000000"
            @open="handleOpenSecond"
            @close="handleCloseSecond"
            @select="handleSelectSecond"
          >
            <template v-for="(sitem,sindex) of menuMainTree">
              <!-- 不含子集 -->
              <el-menu-item
                :index="sitem.url"
                :key="sindex"
                v-if="sitem.list && sitem.list.length === 0"
              >
                <i :class="sitem.icon"></i>
                <span slot="title">{{ sitem.name }}</span>
              </el-menu-item>
              <!-- 包含子集 -->
              <template v-else>
                <el-submenu :index="String(sitem.menuId)" :key="sindex">
                  <template slot="title">
                    <i :class="sitem.icon"></i>
                    <span>{{ sitem.name }}</span>
                  </template>
                  <template v-for="(titem,tindex) of sitem.list">
                    <!-- 包含子子集 -->
                    <el-submenu :index="String(titem.menuId)" v-if="titem.list && titem.list.length > 0" :key="tindex">
                      <template slot="title">{{ titem.name }}</template>
                      <el-menu-item :index="fitem.url" v-for="(fitem,findex) of titem.list" :key="findex">{{ fitem.name }}</el-menu-item>
                    </el-submenu>
                    <!-- 不包含子子集 -->
                    <template v-else>
                      <el-menu-item :index="titem.url" :key="tindex">
                        <template v-if="titem.menuId == 211">
                          <template v-if="`${userInfo.authStatus}` == '0'">三下乡团队管理</template>
                          <template v-else>{{ titem.name }}</template>
                        </template>
                        <template v-else>{{ titem.name }}</template>
                      </el-menu-item>
                    </template>
                  </template>
                </el-submenu>
              </template>
            </template>
          </el-menu>
        </div>
        <!-- 折叠按钮 -->
        <div class="leftbar-side-button" @click="slideShow2()">
          <i :class="modelslideShow?'el-icon-arrow-right':'el-icon-arrow-left'"></i>
        </div>
      </div>
      <div class="main-content">
        <router-view></router-view>
      </div>
    </div>
    <!-- 修改密码弹窗 -->
    <el-dialog
      title="修改密码"
      class="modifyPassword-dialog"
      :close-on-click-modal='false'
      :visible.sync="dialogVisible"
      width="500px">
      <div class="modifyPassword">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="modefiy-ruleForm"
          size="small"
        >
          <el-form-item prop="password">
            <el-input
              prefix-icon="el-icon-lock"
              type="password"
              placeholder="请输入旧密码"
              v-model="ruleForm.password"
            ></el-input>
          </el-form-item>
          <el-form-item prop="newpassword">
            <el-input
              prefix-icon="el-icon-lock"
              type="password"
              maxlength='18'
              placeholder="请输入新密码"
              v-model="ruleForm.newpassword"
            ></el-input>
          </el-form-item>
          <el-form-item prop="newpassword2">
            <el-input
              prefix-icon="el-icon-lock"
              type="password"
              maxlength='18'
              placeholder="请再次输入新密码"
              v-model="ruleForm.newpassword2"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取消修改</el-button>
        <el-button size="small" type="primary" @click="modifyFormPswd('ruleForm')">确定修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { Menu, Submenu, MenuItem, Button, Badge, Dialog, Form, FormItem, Input } from 'element-ui'
import { setCookie, getCookie } from '@/util/utils.js'
export default {
  data () {
    var validatePassword = (rule, value, callback) => {
      //console.log(this.ruleForm)
      // eslint-disable-next-line
      var pattern = /[`~!@#$^&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]/g // 特殊字符
      var alphanumericReg = new RegExp('^(?![0-9]+$)(?![a-zA-Z]+$)') // 必须是字母与数字结合
      // if (pattern.test(value)) {
      //   callback(new Error('密码不能包含特殊字符或空格'))
      // } else 
      if (!alphanumericReg.test(value)) {
        callback(new Error('密码必须是字母与数字结合'))
      } else {
        callback()
      }
    };
    var isSame = (rule, value, callback) => {
      if(value !== this.ruleForm.newpassword ){
        callback(new Error('两次输入的新密码不相同，请重新输入'))
      }else{
        callback()
      }
    }
    return {
      userInfo: {},
      openeds: ['101', '201', '301'],
      dialogVisible: false,
      ruleForm: {
        password: '',
        newpassword: '',
        newpassword2: ''
      },
      rules: {
        password: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newpassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 18, message: '密码长度在 6 到 18 之间', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        newpassword2: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { min: 6, max: 18, message: '密码长度在 6 到 18 之间', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' },
          { validator: isSame, trigger: 'blur' }
        ]
      },
      slideShow: false,
      modelslideShow: false,
      menuTree: [{
        icon: "el-icon-service",
        list: [{
          icon: "el-icon-share",
          list: [],
          menuId: 2,
          name: "数据中心",
          parentId: 1,
          url: "/overview"
        }],
        menuId: 1,
        name: "数据概览",
        parentId: 0,
      }, {
        icon: "el-icon-service",
        list: [{
          icon: "el-icon-share",
          list: [],
          menuId: 4,
          name: "组织机构",
          parentId: 3,
          url: "/organization"
        }],
        menuId: 3,
        name: "组织机构数据",
        parentId: 0,
      }, {
        icon: "el-icon-service",
        list: [{
          icon: "el-icon-share",
          list: [],
          menuId: 6,
          name: "项目中心",
          parentId: 5,
          url: "/project"
        }],
        menuId: 5,
        name: "项目数据",
        parentId: 0,
      }, 
      // {
      //   icon: "el-icon-office-building",
      //   list: [{
      //     icon: "el-icon-share",
      //     list: [],
      //     menuId: 21,
      //     name: "单位维度（导出）",
      //     parentId: 20,
      //     url: "/unit_dimension"
      //   }],
      //   menuId: 20,
      //   name: "单位维度",
      //   parentId: 0,
      // }, 
      {
        icon: "el-icon-school",
        list: [{
          icon: "el-icon-school",
          list: [],
          menuId: 23,
          name: "学校维度（导出）",
          parentId: 22,
          url: "/school_dimension"
        }],
        menuId: 22,
        name: "学校维度",
        parentId: 0,
      }, {
        icon: "el-icon-service",
        list: [{
          icon: "el-icon-share",
          list: [],
          menuId: 8,
          name: "学生数据",
          parentId: 7,
          url: "/student"
        }],
        menuId: 7,
        name: "学生维度",
        parentId: 0,
      }, {
        icon: "el-icon-setting",
        list: [{
          icon: "el-icon-share",
          list: [],
          menuId: 10,
          name: "账号管理",
          parentId: 9,
          url: "/user"
        }],
        menuId: 9,
        name: "系统设置",
        parentId: 0,
      }], // 菜单树数据(一级菜单)
      second_menuTree: [{ // 默认二级菜单展示项
        icon: "el-icon-share",
        list: [],
        menuId: 2,
        name: "数据中心",
        parentId: 1,
        url: "/overview"
      }],
      menuMainTree: [{
        icon: "el-icon-service",
        list: [{
          icon: "el-icon-share",
          list: [],
          menuId: 2,
          name: "数据概览",
          parentId: 1,
          url: "/overview"
        },{
          icon: "el-icon-share",
          list: [],
          menuId: 6,
          name: "项目数据",
          parentId: 5,
          url: "/project"
        },{
          icon: "el-icon-school",
          list: [],
          menuId: 23,
          name: "学校维度",
          parentId: 22,
          url: "/school_dimension"
        },{
          icon: "el-icon-share",
          list: [],
          menuId: 8,
          name: "学生维度",
          parentId: 7,
          url: "/student"
        }],
        menuId: 101,
        name: "返家乡",
        parentId: 0,
      },{
        icon: "el-icon-share",
        list: [{
          icon: "el-icon-share",
          list: [],
          menuId: 211,
          name: "三下乡团队列表",
          parentId: 3,
          url: "/teamVillage/teamManage"
        },{
          icon: "el-icon-share",
          list: [],
          menuId: 212,
          name: "“揭榜”攻关团队数据",
          parentId: 3,
          url: "/teamVillage/topTeam"
        },{
          icon: "el-icon-share",
          list: [],
          menuId: 213,
          name: "团队报备数据",
          parentId: 3,
          url: "/teamVillage/teamReport"
        },{
          icon: "el-icon-share",
          list: [],
          menuId: 214,
          name: "专项活动团队数据",
          parentId: 3,
          url: "/teamVillage/activityTeam"
        }],
        menuId: 201,
        name: "三下乡",
        parentId: 0,
      },{
        icon: "el-icon-office-building",
        list: [{
          icon: "el-icon-share",
          list: [],
          menuId: 4,
          name: "组织机构数据",
          parentId: 3,
          url: "/organization"
        }],
        menuId: 401,
        name: "组织机构数据",
        parentId: 0,
      },{
        icon: "el-icon-setting",
        list: [{
          icon: "el-icon-share",
          list: [],
          menuId: 10,
          name: "账号管理",
          parentId: 9,
          url: "/user"
        }],
        menuId: 301,
        name: "系统设置",
        parentId: 0,
      }],
      // 页面子集菜单
      thisPath: this.$route.path
    }
  },
  components: {
    'el-menu': Menu,
    'el-submenu': Submenu,
    'el-menu-item': MenuItem,
    'el-button': Button,
    'el-badge': Badge,
    'el-dialog': Dialog,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input
  },
  watch: {
    dialogVisible(val){
      if(!val){
        this.$refs['ruleForm'].resetFields()
      }
    },
    'ruleForm.newpassword': function(val){
      if(this.ruleForm.newpassword2 === ''){
        return false
      }else{
        this.$refs.ruleForm.clearValidate('newpassword2'); 
        this.ruleForm.newpassword2 = ''
      }
    }
  },
  created () {
    // 获取用户信息
    let _this = this
    this.getUserinfo(() => {
      _this.userInfo = JSON.parse(sessionStorage.getItem('userinfo'))
    })
    // 初始化判断是否停留在二级菜单上，如果没有默认第一级菜单的第一个子菜单
    if (JSON.parse(sessionStorage.getItem('menulistCache')) && JSON.parse(sessionStorage.getItem('menulistCache')) !== null) {
      // this.second_menuTree = JSON.parse(sessionStorage.getItem('menulistCache'))
    } else {
      // this.second_menuTree = this.menuTree[0].list
    }
  },
  beforeMount () {
  },
  mounted () {
  },
  methods: {
    // 修改密码开启弹窗
    modPassword(){
      this.dialogVisible = true
    },
    // 确定修改密码
    modifyFormPswd (rulename) {
      this.$refs[rulename].validate((valid) => {
        if (valid) {
          this.$confirm('修改成功后直接跳转至登录页?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            this.$http({
              method: 'post',
              url: '/sys/user/password',
              params: {
                oldPassword: this.ruleForm.password,
                newPassword: this.ruleForm.newpassword
              }
            }).then(res => {
              if (res.code === 100) {
                this.$message.success('修改密码成功');
                this.$router.replace('/login')
              } else {
                this.$message.error(res.msg || res.result.msg);
              }
            }).catch(error => {
              console.log(error)
              return false
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消修改'
            })      
          })
        }
      })
    },
    // 一级菜单点击事件
    toTwoMenu (item) {
      let menuId = item.menuId
      for (let i = 0; i < this.menuTree.length; i++) {
        const e = this.menuTree[i]
        if (e.menuId === menuId) {
          this.second_menuTree = e.list
          sessionStorage.setItem('menulistCache', JSON.stringify(this.second_menuTree))
          break
        }
      }
      // 点击一级菜单默认跳转到一级菜单下的第一个路由
      // 1.判断一级菜单是否有url参数，如果有就跳转，如果没有，钻取子集list
      if (!item.url || item.url === '') {
        let twoMenulist = item.list[0]
        if (!twoMenulist.url || item.url === null) {
          let threeMenulist = twoMenulist.list[0]
          this.$router.push({
            path: threeMenulist.url
          })
          this.thisPath = threeMenulist.url
          this.slideShow = false
        } else {
          this.$router.push({
            path: twoMenulist.url
          })
          this.thisPath = twoMenulist.url
          this.slideShow = false
        }
      } else {
        this.$router.push({
          path: item.url
        })
        this.thisPath = item.url
        this.slideShow = false
      }
      // 点击一级菜单，默认展开二级菜单
      this.modelslideShow = false
    },
    // 三级菜单点击事件
    threeLink (url, item) {
      if (url && url !== null) {
        this.$router.push({
          path: url
        })
      } else {
        this.clicktwoMenu(item)
      }
    },
    // 菜单按钮点击事件
    slideShow1 () {
      // this.slideShow = true
      this.modelslideShow = !this.modelslideShow
    },
    slideShow2 () {
      this.modelslideShow = !this.modelslideShow
    },
    // 侧边栏一级菜单展开子菜单事件
    handleOpen (key, keyPath) {
      //console.log(key, keyPath)
    },
    // 侧边栏一级菜单关闭子菜单事件
    handleClose (key, keyPath) {
      //console.log(key, keyPath)
    },
    // 侧边栏一级菜单选中事件
    handleSelectSecond (index, indexPath) {
      this.thisPath = index
    },
    // 侧边栏二级菜单展开子菜单事件
    handleOpenSecond (key, keyPath) {
      //console.log(key, keyPath)
    },
    // 侧边栏二级菜单关闭子菜单事件
    handleCloseSecond (key, keyPath) {
      //console.log(key, keyPath)
    },
    // 侧边栏二级菜单选中事件
    handleSelect (index, indexPath) { },
  }
}
</script>

<style scoped="scoped" lang="scss">
.menu-body {
  position: absolute;
  height: 100vh;
  width: 100vw;
}
// 菜单头部
.menu-head {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  z-index: 9;
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.08);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.08);
  background-color: #fff;
  display: flex;
  align-items: center;
}
.menu-head-button {
  float: left;
  height: 50px;
  width: 50px;
  line-height: 50px;
  background-color: #484848;
  font-size: 12px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  .menu-head-icon {
    background-image: url(../../assets/image/icon-top-menu.png);
    width: 20px;
    height: 16px;
  }
}
.menu-head-title {
  display: flex;
  align-items: center;
  padding-left: 20px;
  font-size: 14px;
  color: #333333;
  font-weight: 700;
  span {
    margin-left: 5px;
  }
}

.icon-logo {
  height: 20px;
  width: 20px;
  background-image: url(../../assets/logo.png);
}

// 菜单侧边栏
.menu-slide {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 5;
  top: 50px;
  width: 0;
}
.menu-slide-shade {
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 6;
  -webkit-transition: all 0.3s cubic-bezier(0, 0, 0.2, 1);
  transition: all 0.3s cubic-bezier(0, 0, 0.2, 1);
}
.menu-slide-wrapper {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 8;
  width: 0;
  overflow: hidden;
  background-color: #ffffff;
  transition: width 0.3s cubic-bezier(0, 0, 0.2, 1);
  -moz-transition: width 0.3s cubic-bezier(0, 0, 0.2, 1);
  -webkit-transition: width 0.3s cubic-bezier(0, 0, 0.2, 1);
  -o-transition: width 0.3s cubic-bezier(0, 0, 0.2, 1);
  .menu-vertical {
    padding: 30px 0;
  }
}
.menu-slide-wrapper.is-visible {
  width: 260px;
}
.loginUser {
  position: absolute;
  right: 0;
  margin-right: 25px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.user-message {
  margin-right: 15px;
}
.icon-user-message {
  font-size: 26px;
  // font-weight: 700;
  color: #333333;
  cursor: pointer;
}
.user-info {
  margin: 0 15px 0 35px;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  .user-info-name {
    font-size: 16px;
    padding-left: 10px;
    line-height: 25px;
    margin-right: 10px;
  }
  .user-info-setPassword{
    font-size: 12px;
    padding-left: 4px;
    line-height: 25px;
    padding-right: 10px;
    color: #2178ec;
  }
  .user-info-setPassword-riLine{
    width: 1px;
    height: 18px;
    background-color: #cccccc;
    margin-top: 4px;
  }
  .user-info-picture {
    width: 25px;
    height: 25px;
    border: 1px solid #f2f2f2;
    border-radius: 50%;
    background-image: url("../../assets/image/icon-user.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
  }
  .user-info-leftarrow {
    font-size: 16px;
    margin-top: 2px;
    padding-left: 10px;
    padding-right: 10px;
    line-height: 25px;
  }
}
.leftbar-side-button {
  position: absolute;
  right: -15px;
  left: auto;
  top: calc(50% - 74px);
  height: 30px;
  border-bottom: 9px solid transparent;
  border-right: none;
  border-left: 14px solid #f0f0f0;
  border-top: 9px solid transparent;
  cursor: pointer;
  z-index: 2;
  i {
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 0;
    margin-left: -13px;
    width: 12px;
    height: 12px;
    margin-top: -6px;
  }
}

// 内容部分
.main-body {
  width: 100vw;
  height: 100vh;
  padding-top: 30px;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  .second-menu {
    width: 216px;
    height: 100%;
    position: relative;
    background-color: #fff;
    border-right: 1px solid #cccccc;
    flex-shrink: 0;
    padding: 35px 0 25px 0;
    box-sizing: border-box;
    overflow-x: initial;
    transition: width 0.3s cubic-bezier(0, 0, 0.2, 1);
    -moz-transition: width 0.3s cubic-bezier(0, 0, 0.2, 1);
    -webkit-transition: width 0.3s cubic-bezier(0, 0, 0.2, 1);
    -o-transition: width 0.3s cubic-bezier(0, 0, 0.2, 1);
  }
  .second-menu.is-active-second {
    width: 0;
  }
  .main-content {
    height: 100%;
    padding-top: 15px;
    flex-grow: 1;
    box-sizing: border-box;
    background-color: #ffffff;
    overflow: auto;
  }
}

// 遮罩层过度效果
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
}
.fade-enter {
  opacity: 0;
}
.fade-enter-to {
  opacity: 1;
}
.fade-leave {
  opacity: 1;
}
.fade-leave-to {
  opacity: 0;
}
// 侧边三级菜单过度效果
.fadeThreemenu-enter-active,
.fadeThreemenu-leave-active {
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
  -o-transition: all 0.2s;
  -moz-transition: all 0.2s;
  -ms-transition: all 0.2s;
}
.fadeThreemenu-enter {
  height: 80px;
}
.fadeThreemenu-enter-to {
  height: 0;
}
.fadeThreemenu-leave {
  height: 0;
}
.fadeThreemenu-leave-to {
  height: 80px;
}
</style>
<!-- elementUI样式 -->
<style >
.menu-head .loginUser .el-badge__content {
  height: 16px;
  line-height: 16px;
  border: 0;
  top: 4px;
}

.menu-slide .menu-vertical > li > ul.el-menu > li.el-menu-item,
.menu-slide
  .menu-vertical
  > li
  > ul.el-menu
  > li.el-submenu
  > .el-submenu__title,
.menu-slide
  .menu-vertical
  > li
  > ul.el-menu
  > li.el-submenu
  > ul.el-menu
  > li.el-menu-item,
.menu-slide .menu-vertical > li.el-menu-item,
.menu-slide .menu-vertical > li > .el-submenu__title {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}
.menu-slide .menu-vertical > li.el-menu-item > i,
.menu-slide .menu-vertical > li > .el-submenu__title > i {
  color: #333333;
  font-size: 14px;
}

.second-menu .menu-vertical > li > ul.el-menu > li.el-menu-item,
.second-menu
  .menu-vertical
  > li
  > ul.el-menu
  > li.el-submenu
  > .el-submenu__title,
.second-menu
  .menu-vertical
  > li
  > ul.el-menu
  > li.el-submenu
  > ul.el-menu
  > li.el-menu-item,
.second-menu .menu-vertical > li.el-menu-item,
.second-menu .menu-vertical > li > .el-submenu__title {
  height: 40px;
  line-height: 40px;
  font-size: 12px;
}
.second-menu .menu-vertical > li > ul.el-menu > li.el-menu-item,
.second-menu
  .menu-vertical
  > li
  > ul.el-menu
  > li.el-submenu
  > .el-submenu__title {
  padding-left: 51px !important;
}
.second-menu .menu-vertical > li > ul.el-menu > li.el-menu-item.is-active,
.second-menu .menu-vertical > li.el-menu-item.is-active,
.second-menu
  .menu-vertical
  > li
  > ul.el-menu
  > li.el-submenu
  > ul.el-menu
  > li.el-menu-item.is-active {
  background-color: #e9f2fd;
}

.second-menu .menu-vertical > li.el-menu-item > i,
.second-menu .menu-vertical > li > .el-submenu__title > i {
  color: #333333;
  font-size: 16px;
}
.second-menu .menu-vertical {
  border-right: 0;
  overflow: hidden;
}
.modifyPassword-dialog .el-dialog__body{
  padding-bottom: 0;
}
.modifyPassword-dialog .modifyPassword .modefiy-ruleForm .el-form-item{
  margin-bottom: 25px;
}
.modifyPassword-dialog .modifyPassword .modefiy-ruleForm .el-input:last-child{
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue